import React from "react";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { useNavigate } from "react-router";
import {
  ELIGIBLE_PRODUCT,
  HowItWorksText,
  useProcessPathPairsContext,
  useEligibilityContext,
  ELIGIBILITY_STATUS,
} from "../../../shared";
import NonEligibleMessage from "src/components/shared/components/nonEligibleMessage";
import { useBundle } from "@amzn/react-arb-tools";
import { HOMEPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const HeresHowItWorks = () => {
  const navigate = useNavigate();
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);
  const { processPathPairs } = useProcessPathPairsContext();
  const isSiteEligible = processPathPairs.length !== 0;
  const { setHasConfirmedEligibility } = useEligibilityContext();

  const onPurchaseYourHeadphones = () => {
    setHasConfirmedEligibility(ELIGIBILITY_STATUS.YES);
    navigate(ELIGIBLE_PRODUCT);
  };

  return (
    <Box
      data-testid="heresHowItWorksElement"
      id="heresHowItWorksElement"
      height="100%"
    >
      <Row widths={["grid-2", "grid-6"]}>
        <Row></Row>
        <Column spacing="500">
          <HowItWorksText></HowItWorksText>
          {isSiteEligible ? (
            <Row>
              <Button onClick={() => onPurchaseYourHeadphones()}>
                {t(bundle, "purchase_your_headphones")}
              </Button>
            </Row>
          ) : (
            <Column>
              <Row>
                <NonEligibleMessage></NonEligibleMessage>
              </Row>
            </Column>
          )}
        </Column>
      </Row>
    </Box>
  );
};

export default HeresHowItWorks;